import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/client';
import B2BTheme, { ExchangeTheme } from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { App } from './App';
import { getRoutes } from './routes';

NewRelicBridge.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());

  if (client.serverData.themeName === 'exchange') {
    client.setTheme({ name: 'exchange', template: ExchangeTheme });
  } else if (client.customer.type === 'b2b') {
    client.setTheme('b2b', B2BTheme);
  }

  client.render(<App />);
});
